module.exports = __webpack_public_path__ + "static/media/img2-1.eeac6826.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/biosense/diff/img2-1.png
// module id = 1163
// module chunks = 3